import React from "react";

const RegistrationStepper = ({ currentStage }) => {
  const steps = [
    { id: 1, title: "Player Details", stage: "basic" },
    { id: 2, title: "Select Package", stage: "package" },
    { id: 3, title: "Review & Pay", stage: "review" },
  ];

  const currentStep =
    steps.findIndex((step) => step.stage === currentStage) + 1;

  return (
    <div className="registration-stepper">
      {steps.map((step, index) => (
        <div className="step-wrapper" key={step.id}>
          <div className="step-item">
            <div
              className={`step-circle ${
                currentStep > step.id
                  ? "completed"
                  : currentStep === step.id
                    ? "active"
                    : ""
              }`}
            >
              {currentStep > step.id ? <i className="fa fa-check" /> : step.id}
            </div>

            <span>{step.title}</span>
          </div>

          {index !== steps.length - 1 && (
            <div
              className={`step-bar ${currentStep > step.id ? "completed" : ""}`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default RegistrationStepper;
